import { useMemo, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';
import { gsap } from 'gsap';

//* Helpers
import { getParamsByKey } from '@/helpers/_functions';

//* Components
import Text from '@/components/common/Text';
import Icon from '@/components/common/Icon';
import CustomLink from '@/components/common/CustomLink';

const FilterItem = ({ title, items, filterType = 'click', filterKey, searchParams, onFilterChange, url, multiple = false }) => {
	//! Pathname
	const pathname = usePathname();

	//! Ref
	const element = useRef();

	//! State
	const [open, setOpen] = useState(true);

	//! Close the item
	const closeItem = () => {
		setOpen(false);

		gsap.killTweensOf(element.current);

		gsap.to(element.current, { duration: 0.5 }).then(() => {
			gsap.to(element.current, { height: 0, duration: 0.5 });
		});
	};

	//! Handle show
	const handleOpen = () => {
		setOpen(!open);

		gsap.killTweensOf(element.current);

		if (!open) {
			gsap.to(element.current, { height: 'auto', duration: 0.5 }).then(() => {
				gsap.to(element.current, { duration: 0.5 });
			});
		} else {
			closeItem();
		}
	};

	//! Active Item
	const selectedValue = useMemo(() => {
		const activeItems = getParamsByKey(searchParams, filterKey);
		return !multiple ? activeItems?.[0] : activeItems;
	}, [searchParams, filterKey]);

	return (
		<div className='filter-item-wrap'>
			<div className={`filter-title-wrap`}>
				{filterKey == 'cat' ? (
					<CustomLink
						url={url}
						className={`cat-name-block`}>
						<Text
							className={'h2 font-futura-medium'}
							text={title}
						/>
					</CustomLink>
				) : (
					<Text
						text={title}
						className={'cat-name-block h2 font-futura-medium'}
					/>
				)}

				{items?.length > 0 ? (
					<Icon
						name={'arrow'}
						onClick={handleOpen}
						className={`p cursor-pointer ${open ? 'active' : ''}`}
					/>
				) : null}
			</div>

			<div
				ref={element}
				className={`inner-content`}>
				{items.map((item, index) => {
					return filterType == 'url' ? (
						<CustomLink
							key={index}
							url={item.url}
							className={`cat-child-name-block ${pathname.includes(item.url) ? 'active' : ''}`}>
							<Text className={'h2 font-futura-regular'}>{item.name}</Text>
						</CustomLink>
					) : (
						<Text
							key={index}
							onClick={() => onFilterChange(filterKey, item.id, multiple)}
							className={`h2 font-futura-regular cat-child-name-block cursor-pointer ${(multiple ? selectedValue?.includes(`${item.id}`) : selectedValue == item.id || (filterKey == 'price' && item.id.split(',')[0] == selectedValue)) ? 'active' : ''}`}>
							{item.name}
						</Text>
					);
				})}
			</div>
		</div>
	);
};

export default FilterItem;
